import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalRef } from '@df/ui/modal/modal-ref';
export namespace NModalLayoutRight {
    /**
     * Default setup for right side modal
     */
    export const ModalConfig: ModalConfig = {
        closeOnNavigation: true,
        height: '100vh',
        maxWidth: undefined,
        transformOptions: `translate3d(100%, 0px, 0px)`,
        modalClass: 'p-a-0',
        position: {
            top: '0',
            bottom: '0',
            right: '0'
        },
        transitionOptions: '500ms ease-in-out'
    };
    export const getWidth = (size: ISizeName): string =>
        ({ S: StylesService.vw(100), M: StylesService.vw(72), L: StylesService.vw(33.82), X: '32.9rem' })[size];
}
@Component({
    selector: 'modal-layout-right',
    templateUrl: 'modal-layout-right.html',
    styleUrls: ['modal-layout-right.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass, NgStyle]
})
export class ModalLayoutRightComponent {
    @Input()
    modalTitle?: string;
    @Input()
    modalSubtitle?: string;
    @Input()
    scrollId?: string;

    @Input()
    smallText = false;

    /**
     * Dependencies
     */
    constructor(private modalRef: ModalRef<ModalLayoutRightComponent>) {}
    /**
     * Close modal
     */
    close() {
        this.modalRef.close();
    }
}
